import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {Routes} from "../ContainerPage";
import {BottomWrapper, CoreWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import H2 from "../../Components/H2";

import {sendValidatePhone, clearValidationHash} from "./Actions";
import {
    CenterContainer,
    FullWidthInput,
    PhoneInputWrapper, SubmitButton,
    TextContainer,
    TextWithIconWrapper,
    TypeNumberMessage
} from "./CommonUI";
import {Checkbox} from 'rmwc/Checkbox';
import {getSafely} from "@tomeravni/easybizy-js-common/common";

const CheckBoxWrapper = styled.div`
    visibility: ${p => p.visible ? 'visible' : 'hidden'};
    opacity: ${p => p.visible ? 1 : 0};
    transform: ${p => p.visible ? 'none' : 'translateX(50%)'};
    transition: all 300ms ease-in;

    a {
        color: ${p => p.theme.colors.primaryText};
    }

    label {
        color: ${p => p.theme.colors.primaryText};
    }

`;

const ButtonWrapper = styled.div`
    height: 30px;
`;


class Identify extends ContainerPage {
    state = {value: '', agreeToTerms: false};

    constructor(props) {
        super(props);
        this.allowAnonymous = true;
        this.nextRoute = Routes.validate;
    }

    didNavigate = false;

    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.didNavigate && nextProps.config && nextProps.config.Customer) {
            this.didNavigate = true;
            this.startOver();
        }
    }

    onChange = (e) => {
        const re = /^[0-9\-\+\b]+$/;
        const currentValue = e.target.value;
        if (currentValue === '' || re.test(currentValue)) {
            let modifiedValue = currentValue.replace(/\-/gi, '');
            const length = modifiedValue.length;
            let desiredLength = 10;
            let value;
            if (modifiedValue.charAt(0) !== '+') {
                if (length > 2) {
                    // Three digits
                    if (modifiedValue.charAt(0) !== '0' || ['5', '7'].indexOf(modifiedValue.charAt(1)) > -1) {
                        if (length > 3) {
                            modifiedValue = modifiedValue.slice(0, 3) + '-' + modifiedValue.slice(3)
                        }
                    } else { // 2 digits
                        desiredLength = 9;
                        modifiedValue = modifiedValue.slice(0, 2) + '-' + modifiedValue.slice(2)
                    }
                }

                value = modifiedValue.slice(0, 11);
            } else {
                value = modifiedValue.slice(0, 12);
                desiredLength = 11;
            }


            this.safeSetState({value: value, valid: value.length === desiredLength + 1});
        }
    };

    componentDidMount() {
        super.componentDidMount();
        setTimeout(() => {
            this.inputField.focus();
        }, 500);
    }

    sendValidationCode() {
        if (!this.state.agreeToTerms) {
            return this.showToastMessage(this.props.intl.formatMessage({id: 'app.mustAgreeToTermsAndPrivacy'}));
        }

        this.props.validate(this.state.value.replace(/\-/gi, ''), this.props.config.Token, (err) => {
            if (!err) {
                this.showToastMessage(this.props.intl.formatMessage({id: 'app.weSentYouApprovalCode'}));
                setTimeout(() => {
                    this.next();
                }, 1000);
            }
        });
    }

    buttonWrapperClicked() {
        if (!this.state.agreeToTerms) {
            this.showToastMessage(this.props.intl.formatMessage({id: 'app.mustAgreeToTermsAndPrivacy'}));
        }
    }

    render() {
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

        return (
            <div className="transition-item detail-page detail-page__identify">
                <CoreWrapper padding={true}
                             loading={!this.props.config || this.props.sendingValidationCode}
                             ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr}
                                     rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={0} visible={true}/>
                    </ToolbarWithLogo>

                    <TopWrapper justify="start" align="start">
                        <CenterContainer>
                            <H2 center={true}><FormattedMessage id="schedule.identifyHeader"/></H2>
                            <H1><FormattedMessage id="schedule.letsMeet"/></H1>
                        </CenterContainer>
                        <TextContainer>
                            <PhoneInputWrapper visible={true}>
                                <TextWithIconWrapper>
                                    <FullWidthInput short={true}
                                                    autoComplete={'off'}
                                                    onKeyDown={(e) => e.key === 'Enter' && this.state.valid && this.sendValidationCode()}
                                                    disabled={this.props.sendingValidationCode}
                                                    value={this.state.value} onChange={this.onChange}
                                                    innerRef={r => this.inputField = r}
                                                    type="tel"
                                                    inputmode="tel"
                                                    id={`text-phone-${Math.random() * 1000000}`}

                                    />
                                    <ButtonWrapper onClick={() => this.buttonWrapperClicked()}
                                                   clickable={!this.state.agreeToTerms}>
                                        <SubmitButton outlined
                                                      disabled={this.props.sendingValidationCode || !this.state.valid || !this.state.agreeToTerms}
                                                      onClick={() => this.sendValidationCode()}><FormattedMessage
                                            id="app.send"/></SubmitButton>
                                    </ButtonWrapper>
                                </TextWithIconWrapper>
                                <TypeNumberMessage short={true}><FormattedMessage
                                    id="schedule.phoneNumber"/></TypeNumberMessage>
                            </PhoneInputWrapper>


                            {this.state.didMount && <CheckBoxWrapper visible={this.state.valid}>
                                <Checkbox
                                    checked={this.state.agreeToTerms}
                                    onChange={evt => this.setState({agreeToTerms: evt.target.checked})}>
								<span><FormattedMessage id="app.agreeToTerms"/><a target="_blank"
                                                                                  href="https://auth.easybizy.net/privacy-customers"><FormattedMessage
                                    id="app.privacy"/></a>&nbsp;
                                    <span><FormattedMessage id="app.and"/><a target="_blank"
                                                                             href="https://auth.easybizy.net/terms-of-use-customers"><FormattedMessage
                                        id="app.terms"/></a>.</span></span>
                                </Checkbox>
                            </CheckBoxWrapper>}


                        </TextContainer>
                        <BottomWrapper empty={true}>
                            <PoweredBy/>
                        </BottomWrapper>
                    </TopWrapper>

                </CoreWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig,
        config: state.schedule.config,
        progress: state.schedule.progress,
        sendingValidationCode: state.identify.sendingValidationCode,
        validationHash: state.identify.validationHashResponse,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        validate: (mobile, token, callback) => dispatch(sendValidatePhone(mobile, token, callback)),
        clearValidationHash: () => dispatch(clearValidationHash())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Identify));
